<template>
  <div class="material-design-icon" id="arrow-left-icon" role="img" aria-labelledby="arrow-left-icon-title">
    <svg class="material-design-icon__svg" width="24" height="24" viewBox="0 0 24 24">
      <title id="arrow-left-icon-title">{{iconTitle}}</title>
      <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z"></path>
    </svg>
  </div>
</template>

<script>
  export default {
    name: "arrow-left-icon",
    data () {
      let iconTitle = this.title ? this.title : "Arrow left icon"

      return {
        iconTitle: iconTitle
      }
    },
    props: {
      title: {
        type: String
      }
    }
  }
</script>



// WEBPACK FOOTER //
// arrow-left.vue?733fde82